import React, { ReactNode, useState } from "react";

import { Collapse, Flex, Icon, Typography } from "components";

// Each automation (remote sensing, doc scan) adds its own card as a child.
export const VerificationAutomations = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(true);

  return (
    <Collapse
      className="verification-automations"
      activeKey={open ? ["automations"] : []}
      onChange={() => setOpen((v) => !v)}
      items={[
        {
          key: "automations",
          showArrow: false,
          label: (
            <Flex align="center" gap="0.375rem">
              <Typography variant="h3" className="margin-0">
                Verification automations
              </Typography>
              <Icon iconName={open ? "tabler/chevron-up" : "tabler/chevron-down"} size="m-light" />
            </Flex>
          ),
          children: <div className="verification-automations-cards">{children}</div>,
        },
      ]}
    />
  );
};
